<template>
  <div :class="jel_getClassObject(content)">
    <div class="container p-0">
      <div
        v-if="isSpinnerVisible"
        id="spinner"
        class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
      >
        <b-spinner :label="$t('chargement')"></b-spinner>
      </div>
      <div class="row">
        <div class="col text-left">
          <!-- Affichage des erreurs systèmes -->
          <div v-if="isErreurServeur">
            <MessageMel
              v-show="contentMessageMel.message"
              :content="contentMessageMel.message"
              class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
            ></MessageMel>
          </div>
          <!-- Aucune erreur système (cas normal)  -->
          <div v-else-if="messages.length > 0">
            <!-- Affichage de la liste des messages -->
            <div
              v-for="message in messages"
              :key="message.id"
              class="message row px-1"
              @click="openModal(message)"
            >
              <template v-if="messagesBienJouer[message.messageCode]">
                <div class="col-2 ml-0 px-0">
                  <span v-if="message.readDate === null" class="enveloppe">
                    <svg-icon
                      icon-name="ic-enveloppe"
                      color="$couleur-primaire"
                      className="iconeEnveloppe"
                    ></svg-icon>
                  </span>
                </div>
                <div class="col-10 ml-0 px-0">
                  <span v-if="message.readDate === null">
                    <strong>
                      {{ messagesBienJouer[message.messageCode].msgTitre }}
                    </strong>
                  </span>
                  <span v-else>
                    {{ messagesBienJouer[message.messageCode].msgTitre }}
                  </span>
                  <br />
                  <span><i>{{ message.createDate.slice(0, message.createDate.indexOf(' ')) }}</i></span>
                </div>
              </template>
            </div>

            <!-- Bouton "Charger plus" centré -->
            <div v-if="hasMoreMessages" class="row px-1">
              <div class="load-more col-12 ml-0 py-1 px-0">
                <b-link class="lienSecondaire" @click="fetchMessages">{{
                  content.libBtnAfficherPlus
                }}</b-link>
              </div>
            </div>

            <!-- Composant modal affiché lors du clic sur un message -->
            <MessageModal
              v-if="showModal"
              :message="selectedMessage"
              :messagesBienJouer="messagesBienJouer"
              @close="closeModal"
              @delete="deleteMessage"
            />
          </div>
          <div v-else>
            <div class="row px-1">
              <div class="col-12 ml-0 py-1 px-0">
                {{ $t('notificationsBienJouer.aucuneNotification') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activite from '@/services/api/compte/activiteJeux';
import MessageMel from '@/components/base/MessageMel';
import MessageHelpers from '@/helpers/MessageHelpers';
import { inMgnl } from '@/helpers/AppHelpers';
import MessageModal from '@/components/base/MessageModal.vue';

export default {
  name: 'CompteNotificationsBienJouer',
  components: {
    MessageModal,
    MessageMel,
  },
  props: { content: { type: Object, required: true }, metadata: { type: Object } },
  data() {
    return {
      isSpinnerVisible: false,
      uuid: null,
      contentMessageMel: {
        message: {},
        alert: {},
      },
      messagesBienJouer: {},
      isErreurServeur: false,
      messages: [],
      limit: 10,
      offset: 0,
      hasMoreMessages: true,
      showModal: false,
      selectedMessage: null,
    };
  },
  computed: {},
  mounted() {
    if (inMgnl) {
      this.isSpinnerVisible = false;
    }
    this.uuid = sessionStorage.getItem('lq_client_uuid');

    this.recupererTousLesMsg()
      .then((fetchedMessagesFromMgnl) => {
        fetchedMessagesFromMgnl.forEach((item) => {
          this.$set(this.messagesBienJouer, item.msgCode, item);
        });
      })
      .catch((error) => console.error('Erreur lors de la récupération des messages :', error));

    this.fetchMessages();
  },
  methods: {
    async fetchMessages() {
      try {
        const response = await activite.getMessages(this.uuid, this.limit, this.offset);
        response.forEach((item) => {
          this.messages.push(item);
        });
        this.hasMoreMessages = response.length >= this.limit;
        this.offset += this.limit;
        this.isSpinnerVisible = false;
      } catch (error) {
        console.error('Erreur lors du chargement des messages :', error);
      }
    },
    async openModal(message) {
      try {
        await activite.setReadMessage(this.uuid, message.id);
        this.$set(message, 'readDate', new Date().toISOString());
      } catch (error) {
        console.error('Erreur lors de la mise à jour du message comme lu :', error);
      }
      this.selectedMessage = message;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedMessage = null;
    },
    async deleteMessage() {
      try {
        await activite.deleteMessage(this.uuid, this.selectedMessage.id);
        this.messages = this.messages.filter((msg) => msg.id !== this.selectedMessage.id);
        this.closeModal();
      } catch (error) {
        console.error('Erreur lors de la suppression du message :', error);
      }
    },
    async recupererTousLesMsg() {
      return MessageHelpers.getMessagesPageCourante(this.$root);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
}
.message {
  padding: 10px;
  background-color: #f5f2e8;
  cursor: pointer;
  margin-bottom: 4px;
  font-size: 16px;
  color: #020a30;
  line-height: 140%;
  div:first-child {
    text-align: center;
  }
}
.load-more {
  text-align: center;
  margin: 20px 0;
  background: none;
  .lienSecondaire {
    font-size: 1rem;
    line-height: 1rem;
    color: $couleur-primaire;
  }
}
.iconeEnveloppe {
  color: $couleur-primaire;
  height: 1.5rem;
  width: 1.5rem;
}
</style>
